import { render, staticRenderFns } from "./ImageSelectTemplate.vue?vue&type=template&id=1810a870&"
import script from "./ImageSelectTemplate.vue?vue&type=script&lang=js&"
export * from "./ImageSelectTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports